export const PRIVACY_CONTENT = `
# Política de Privacidad

**Última actualización: julio de 2026**

## 1. Responsable del tratamiento

La presente Política de Privacidad regula el tratamiento de datos personales realizado por **John Anthony** (en adelante, "el Servicio"), plataforma de análisis estadístico deportivo accessible a través de Telegram.

## 2. Datos que recopilamos

Al usar el Servicio, podemos recopilar los siguientes datos:

- **Identificador de Telegram**: ID de usuario de Telegram, necesario para identificarte en la Mini App.
- **Nombre de usuario**: Nombre de pantalla de Telegram, utilizado para personalizar la experiencia.
- **Datos de suscripción**: Plan contratado, fecha de inicio y estado de la suscripción.
- **Datos de pago**: Procesados exclusivamente por Stripe o Bizum. No almacenamos datos de tarjeta.

## 3. Finalidad del tratamiento

Los datos se utilizan para:

- Gestionar tu cuenta y plan de suscripción.
- Enviarte picks y notificaciones dentro de la Mini App de Telegram.
- Calcular y publicar estadísticas de rendimiento (de forma agregada y anónima).
- Gestionar pagos y renovaciones de suscripción.
- Mejorar los modelos de análisis del sistema.

## 4. Base legal

El tratamiento de datos se basa en:

- **Ejecución del contrato**: Para prestarte el servicio contratado.
- **Interés legítimo**: Para mejorar la plataforma y prevenir fraudes.
- **Consentimiento**: Para comunicaciones opcionales.

## 5. Conservación de datos

Los datos se conservan durante el tiempo que mantengas tu cuenta activa más un período adicional de **3 años** para cumplimiento legal. Los datos de pago los conserva Stripe según sus propias políticas.

## 6. Compartición de datos

No vendemos ni cedemos tus datos a terceros, salvo:

- **Stripe**: Procesador de pagos, para gestionar suscripciones.
- **Telegram**: Plataforma necesaria para el funcionamiento de la Mini App.
- **Obligaciones legales**: Cuando sea requerido por autoridades competentes.

## 7. Tus derechos

Puedes ejercer en cualquier momento los derechos de:

- **Acceso**: Conocer qué datos tenemos sobre ti.
- **Rectificación**: Corregir datos incorrectos.
- **Supresión**: Solicitar la eliminación de tus datos.
- **Portabilidad**: Recibir tus datos en formato estructurado.
- **Oposición**: Oponerte a ciertos tratamientos.

Para ejercer estos derechos, contacta con nosotros a través de Telegram.

## 8. Seguridad

Implementamos medidas técnicas y organizativas para proteger tus datos, incluyendo cifrado en tránsito (HTTPS/TLS) y en reposo.

## 9. Cookies

Esta landing page puede utilizar cookies técnicas necesarias para el funcionamiento básico. No utilizamos cookies de seguimiento ni publicidad de terceros.

## 10. Contacto

Para cualquier consulta sobre privacidad, contacta a través del soporte en Telegram: **@Jhon_sportbot**

---

*Esta política puede actualizarse periódicamente. Te notificaremos cambios significativos.*
`
